(function() {
    'use strict';

    angular
        .module('bhsApp')
        .controller('DataElementDeleteController',DataElementDeleteController);

    DataElementDeleteController.$inject = ['$uibModalInstance', 'entity', 'DataElement'];

    function DataElementDeleteController($uibModalInstance, entity, DataElement) {
        var vm = this;

        vm.dataElement = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            DataElement.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();
